import React from "react"

export default function ArrowDownward() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_171_7343)">
            <path d="M12.0917 16.5243L5.25935 9.69185C4.92983 9.36233 4.92983 8.82809 5.25935 8.49861L6.05623 7.70172C6.38519 7.37276 6.91833 7.37213 7.24807 7.70031L12.6884 13.1151L18.1286 7.70031C18.4583 7.37213 18.9915 7.37276 19.3204 7.70172L20.1173 8.49861C20.4468 8.82813 20.4468 9.36236 20.1173 9.69185L13.285 16.5243C12.9555 16.8537 12.4212 16.8537 12.0917 16.5243Z" fill="#5B5E71" />
         </g>
         <defs>
            <clipPath id="clip0_171_7343">
               <rect width="15.75" height="18" fill="white" transform="translate(4.81323 3.11255)" />
            </clipPath>
         </defs>
      </svg>
   )
}